module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"plan":"Your plan","plans":"Plans and quotes","history":"Payment History","info":"Payment info","trial":"Trial period","transaction":"Transactions","payments":"Payments","loyaltyProgram":"Loyalty program"}}')
  delete Component.options._Ctor
}
